import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants"

const API_CONTROLLER = "ward";

export class OrganizationApi {
  static updateOrganizationContacts(wardId, orgCode, bulkUpdates){
    const url = `${ROOT_URL}/${API_CONTROLLER}/${wardId}/organization/${orgCode}/contact-updates`
    return authAxios.post(url, bulkUpdates)
  }
}
